
import {Layout} from "antd";

import LayoutProfile from "../Profile/LayoutProfile";

export const UserTemplate = ({routes, open, setOpen, ModalComponent, isMobile, uiTexts}) => {

  const { Header, Content, Sider } = Layout;

  //isMobile = max-width: 992px

  return(
    <>
      {
        !isMobile ?
          <LayoutProfile routes={routes} />
          // <Layout>
          //   <Header className={"main-header"}>
          //     <SearchBarBlog/>
          //   </Header>
          //   <Layout>
          //     <Layout>
          //       <Header className={"user-header"}>
          //         <UserHeader
          //           open={open}
          //           setOpen={setOpen}
          //           ModalComponent={ModalComponent}
          //           isMobile={isMobile}
          //           uiTexts={uiTexts}
          //         />
          //       </Header>
          //       <Layout>
          //         <Sider className={"user-right-sider"}>
          //           <UserSider />
          //         </Sider>
          //         <Content className={"content-menu-publications"}>
          //           {routes}
          //         </Content>
          //       </Layout>
          //     </Layout>
          //     <Sider className={"following-menu"}>
          //       <FollowersSider
          //         uiTexts={uiTexts}
          //       />
          //     </Sider>
          //   </Layout>
          // </Layout>
          :
          // <Layout>
          //   <Header className={"main-header"}>
          //     <SearchBarBlog/>
          //   </Header>
          //   <Layout>
          //     <Header className={"user-header"}>
          //       <UserHeader
          //        open={open}
          //        setOpen={setOpen}
          //        ModalComponent={ModalComponent}
          //         isMobile={isMobile}
          //         uiTexts={uiTexts}
          //       />
          //     </Header>
          //     <Sider className={"user-right-sider"}>
          //       <UserSider />
          //     </Sider>
          //     <Content className={"content-menu-publications"}>
          //       {routes}
          //     </Content>
          //   </Layout>
          // </Layout>
          <LayoutProfile routes={routes} />
      }
    </>
  );
};